export default __webpack_public_path__ + "static/media/amerp.1c4b162a.png";